import { useEffect } from "react";
import { matchRoutes, useLocation } from "react-router-dom";
import { PAGE_TITLES } from "@/config/page-titles.config";
import { selectDynamicTitle, useDocumentTitleStore } from "@/store/document-title/document-title.store";

export const APP_TITLE = "IronPipeline";

const TITLE_ROUTES = PAGE_TITLES.map(({ path, title }) => ({ path, title }));

/**
 * Single writer of `document.title`, mounted once in App. Title precedence:
 * dynamic title from the mounted screen (`usePageTitle`) → static title of
 * the matched route (`PAGE_TITLES`) → "IronPipeline".
 */
const DocumentTitleSync = () => {
  const location = useLocation();
  const dynamicTitle = useDocumentTitleStore(selectDynamicTitle);
  const matches = matchRoutes(TITLE_ROUTES, location);
  const routeTitle = matches?.[matches.length - 1]?.route.title ?? null;
  const title = dynamicTitle ?? routeTitle;

  useEffect(() => {
    document.title = title ? `${title} · ${APP_TITLE}` : APP_TITLE;
  }, [title]);

  return null;
};

export default DocumentTitleSync;
